import React from "react";

/**
 * Obtížnost šití.
 *
 * `difficulty` přichází z API jako ID parametru z DB (tabulka `parameter`, type='difficulty'):
 *   1  = Začátečníci
 *   22 = Mírně pokročilí
 *   21 = Pokročilé
 *   23 = Zkušení
 *
 * Pozn.: dřív se na frontendu switchovalo na 1/2/3, takže produkty s ID 21/22/23
 * (většina katalogu) neměly žádný odznak. Tohle je jediné správné mapování.
 */
export interface DifficultyBadge {
    label: string;
    /** CSS třída pro <span> odznaku. Základní `.level` = oranžová (Pokročilé). */
    className: string;
}

export function getDifficultyBadge(difficulty: number): DifficultyBadge | null {
    switch (difficulty) {
        case 1:  return { label: "Začátečníci",     className: "level green" };
        case 22: return { label: "Mírně pokročilí", className: "level yellow" };
        case 21: return { label: "Pokročilé",       className: "level" };
        case 23: return { label: "Zkušení",         className: "level red" };
        default: return null;
    }
}

/** Hotový <span> odznak, nebo null. */
export function renderDifficultyBadge(difficulty: number): React.ReactElement | null {
    const badge = getDifficultyBadge(difficulty);
    if (!badge) return null;
    return React.createElement("span", { className: badge.className }, badge.label);
}
